module.exports = __webpack_public_path__ + "img/cuba.29c97ef2.svg";